import {PLAN_HIERARCHY, PlanId} from "./silverplus.constants.ts";

export const parsePlanId = (label?: string): PlanId => {
    if (!label) return '0';
    const months = label.match(/(\d+) Monate/)?.[1];
    return (months as PlanId) || '0';
};

export const formatDate = (timestamp: number): string => {
    const date = timestamp > 10000000000
        ? new Date(timestamp)
        : new Date(timestamp * 1000);

    return date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

export const getCurrentTimeInSeconds = () => Date.now() / 1000;

export const canUpgrade = (from: PlanId, to: PlanId): boolean =>
    PLAN_HIERARCHY[to] > PLAN_HIERARCHY[from];

